import { getAllAccounts } from '@/api/apiManagerApi';
import { QUERY_REFETCH_INTERVAL } from '@/lib/constants';
import type { ExchangeAccount } from '@/state/exchanges/exchangesSliceTypes';
import { EXCHANGES } from '@/lib/types/generalTypes';

export const ACCOUNTS_QUERY_KEY = ['accounts'] as const;

export const accountsQuery = {
    queryKey: ACCOUNTS_QUERY_KEY,
    queryFn: async (): Promise<ExchangeAccount[]> => {
        const response = await getAllAccounts();
        return response.data.map(({ secret, passphrase, ...item }) => ({
            ...item,
            exchangeId: item.exchange.toLowerCase() as EXCHANGES,
            deposit: { usd: 0, gbp: 0 },
            depositBtc: 0,
        }));
    },
    staleTime: QUERY_REFETCH_INTERVAL,
};
